import { apiBlobRequest, apiRequest, type BlobDownload } from '../api/http'
import type { ChannelInventoryVarianceParams, ChannelInventoryVarianceReport, HomeDashboard } from './types'

const DASHBOARD_BASE = '/api/dashboard'

export function getHomeDashboard(accessToken: string): Promise<HomeDashboard> {
  return apiRequest<HomeDashboard>(DASHBOARD_BASE, '/home', { accessToken })
}

export function getChannelInventoryVariance(
  accessToken: string,
  params: ChannelInventoryVarianceParams = {},
): Promise<ChannelInventoryVarianceReport> {
  return apiRequest<ChannelInventoryVarianceReport>(DASHBOARD_BASE, `/channel-inventory-variance${varianceQuery(params)}`, { accessToken })
}

export function exportChannelInventoryVariance(
  accessToken: string,
  params: Omit<ChannelInventoryVarianceParams, 'page' | 'size'> = {},
): Promise<BlobDownload> {
  return apiBlobRequest(DASHBOARD_BASE, `/channel-inventory-variance/export${varianceQuery(params)}`, { accessToken })
}

function varianceQuery(params: ChannelInventoryVarianceParams): string {
  const search = new URLSearchParams()
  if (params.page != null) search.set('page', String(params.page))
  if (params.size != null) search.set('size', String(params.size))
  const query = params.query?.trim()
  if (query) search.set('query', query)
  if (params.provider) search.set('provider', params.provider)
  if (params.channelConnectionId != null) search.set('channelConnectionId', String(params.channelConnectionId))
  if (params.warehouseId != null) search.set('warehouseId', String(params.warehouseId))
  if (params.sortBy) search.set('sortBy', params.sortBy)
  if (params.sortDirection) search.set('sortDirection', params.sortDirection)
  const suffix = search.toString()
  return suffix ? `?${suffix}` : ''
}
